export enum ProductExpansionMode {
  Upload = 'upload',
  ExistingProduct = 'existing_product',
}
